export class EncodingService {

  public static encode(payload: object): string {
    const serialized = JSON.stringify(payload);
    return btoa(serialized);
  }

  public static decode(encoded: string): object {
    const decoded = atob(encoded);
    return JSON.parse(decoded);
  }
}